"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.insuranceHandlers = exports.deleteCard = exports.uploadCard = exports.getCards = exports.getCardTypes = void 0;
var instance_1 = require("./instance");
var msw_1 = require("msw");
var mock = {};
function parseInsuranceCard(raw) {
    return __assign(__assign({}, raw), { frontImage: "data:image/jpeg;base64, ".concat(raw.frontImage), backImage: "data:image/jpeg;base64, ".concat(raw.backImage), uploadedDate: new Date(raw.uploadedDate) });
}
function getCardTypes() {
    return (0, instance_1.getInstance)()
        .request({
        url: "/InsuranceCard/CardTypes",
        method: "GET",
    })
        .then(function (response) { return response.data; });
}
exports.getCardTypes = getCardTypes;
mock.getCardTypes = function () {
    return msw_1.rest.get("".concat((0, instance_1.getBaseURL)(), "/InsuranceCard/CardTypes"), function (req, res, ctx) {
        return res(ctx.delay(2000), ctx.status(200), ctx.json([
            { cardType: 1, description: "Primary card" },
            { cardType: 2, description: "Secondary card" },
            { cardType: 3, description: "Tertiary card" },
        ]));
    });
};
function getCards(patientId) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/InsuranceCard",
        method: "GET",
        params: { patientId: patientId },
    })
        .then(function (response) { return response.data.map(parseInsuranceCard); });
}
exports.getCards = getCards;
mock.getCards = function () {
    return msw_1.rest.get("".concat((0, instance_1.getBaseURL)(), "/InsuranceCard"), function (req, res, ctx) {
        return res(ctx.delay(2000), ctx.status(200), ctx.json([
            {
                id: 1,
                cardType: 1,
                description: "Primary card",
                frontImage: "",
                backImage: "",
                uploadedDate: "2023-07-11T19:47:15.922Z",
            },
        ]));
    });
};
function uploadCard(req) {
    var data = new FormData();
    // mobile returns uri strings for image data, so include any not-provided info if just uri
    if (typeof req.frontImage === "string" && typeof req.backImage === "string") {
        data.append("frontFile", {
            name: req.frontImage,
            uri: req.frontImage,
            type: "image/jpeg",
        });
        data.append("backFile", {
            name: req.backImage,
            uri: req.backImage,
            type: "image/jpeg",
        });
    }
    else {
        data.append("frontFile", req.frontImage);
        data.append("backFile", req.backImage);
    }
    return (0, instance_1.getInstance)()
        .request({
        url: "/InsuranceCard/".concat(req.cardType),
        params: { patientId: req.patientId },
        method: "PUT",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
        },
    })
        .then(function (response) { return parseInsuranceCard(response.data); });
}
exports.uploadCard = uploadCard;
mock.uploadCard = function () {
    return msw_1.rest.put("".concat((0, instance_1.getBaseURL)(), "/InsuranceCard/:cardType"), function (req, res, ctx) {
        return res(ctx.delay(2000), ctx.status(200), ctx.json({
            id: parseInt(req.params.cardType, 10) + 1000,
            cardType: parseInt(req.params.cardType, 10),
            description: "Some card",
            frontImage: "",
            backImage: "",
            uploadedDate: "2023-07-11T19:47:15.922Z",
        }));
    });
};
function deleteCard(id) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/InsuranceCard/".concat(id),
        method: "DELETE",
    })
        .then(function (response) { return parseInsuranceCard(response.data); });
}
exports.deleteCard = deleteCard;
mock.deleteCard = function () {
    return msw_1.rest.delete("".concat((0, instance_1.getBaseURL)(), "/InsuranceCard/:id"), function (req, res, ctx) {
        return res(ctx.delay(2000), ctx.status(200), ctx.json({
            id: parseInt(req.params.id, 10),
            cardType: 1,
            description: "Some card",
            frontImage: "",
            backImage: "",
            uploadedDate: "2023-07-11T19:47:15.922Z",
        }));
    });
};
exports.insuranceHandlers = mock;
